export const PAGE_LOADER_ID = 'pageLoader';
export const APP_ROOT_ID = 'root';
export const MODAL_ROOT_ID = 'modal-root';

export const pageLoaderEl = document.getElementById(PAGE_LOADER_ID) as HTMLElement;
export const rootEl = document.getElementById(APP_ROOT_ID) as HTMLElement;
export const modalRootEl = document.getElementById(MODAL_ROOT_ID) as HTMLElement;
